<template> 
  <div class="itinerario-root">
    <!-- 🔹 Portada arriba (se mantiene la imagen, SIN velo) -->
    <div class="imagen-portada-wrapper">

      <!-- 🎥 VIDEO -->
      <video
        ref="videoPortada"
        class="video-portada"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        preload="auto"
      >
        <source src="@/assets/VIDEO.mp4" type="video/mp4" />
      </video>

    
      <!-- <div class="portada-velo"></div>  --> <!-- Eliminado -->
    </div>

    <!-- 🔹 Contenedor del itinerario -->
    <div class="itinerario-container" ref="contenedorRef"><br><br>
      <h2 class="titulo">Itinerario</h2>
      <div class="timeline">
        <div
          v-for="(evento, index) in eventos"
          :key="index"
          :ref="el => { if (el) eventosRef[index] = el }"
          class="timeline-item"
        >
          <!-- Ícono a la izquiasasasasdasdsdasdasdasdasdasdasdasdasderda -->
          <div class="lado-izquierdo">
            <div class="icono-wrapper">
              <img :src="evento.icono" alt="icono evento" class="icono" />
            </div>
          </div>

          <!-- Corazón al centro -->
          <div class="corazon">
            <img src="@/assets/corazon.png" alt="corazon" class="corazon-img" />
          </div>

          <!-- Texto a la derecha -->
          <div class="lado-derecho">
            <p class="hora">{{ evento.hora }}</p>
            <p class="nombre">{{ evento.titulo }}</p>
          </div>
        </div>
      </div>
      <br>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'ItinerarioLadoIzqDer',
  setup() {
    const contenedorRef = ref(null)
    const eventosRef = ref([])
    const imagenPortada = ref(null)
    const videoPortada = ref(null)

    const eventos = ref([

      { titulo: 'Ceremonia Religiosa', hora: '4:00 p.m.', icono: require('@/assets/igle.png') },
      { titulo: 'Recepción', hora: '6:00 p.m.', icono: require('@/assets/recepcion_time.png') },
      { titulo: 'Ceremonia Civil', hora: '7:00 p.m.', icono: require('@/assets/cheers-itinerario.svg') },
      { titulo: 'Cena - Baile', hora: '7:30 - 12:00 pm', icono: require('@/assets/cena_time.png') },

    ])

    onMounted(() => {

      if (videoPortada.value) {
        videoPortada.value.play().catch(() => {})
      }

      if (imagenPortada.value) {
        gsap.fromTo(
          imagenPortada.value,
          { opacity: 0, y: -20, scale: 1.04 },
          { opacity: 1, y: 0, scale: 1, duration: 1.2, ease: 'power2.out' }
        )
      }

      eventosRef.value.forEach(el => gsap.set(el, { opacity: 0, y: 30 }))
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const index = eventosRef.value.findIndex(e => e === entry.target)
          if (entry.isIntersecting && index !== -1) {
            gsap.to(entry.target, {
              opacity: 1,
              y: 0,
              duration: 0.8,
              delay: index * 0.15,
              ease: 'power2.out'
            })
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.3 })

      eventosRef.value.forEach(el => el && observer.observe(el))
    })

    return {
      contenedorRef,
      eventosRef,
      eventos,
      imagenPortada,
      videoPortada
    }
  }
}
</script>

<style scoped>
/* ====== Portada arriba ====== */
.itinerario-root {
   margin-bottom: -30px;
  
}
.imagen-portada-wrapper {
  width: 100%;
  height: 560px;
  overflow: hidden;
  position: relative;

}

.video-portada{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

.imagen-portada {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0; /* animación de entrada */
}
/* .portada-velo {  <-- Eliminado
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(255,255,255,0.0), rgba(255,255,255,0.92) 68%);
} */

/* ====== Timeline ====== */
.itinerario-container {
  padding: 0px 0px;
    background-image: url('@/assets/7.png'); /* 🔹 pon tu imagen aquí */
     background-size: cover;      /* 🔹 la imagen cubre todo */
  background-position: center; /* centrada */
  background-repeat: no-repeat; /* no se repite */ 
  padding-bottom: 45px;
  width:70hv;
  text-align: center;
  font-family: 'Playfair Display', serif;
}

.titulo {
  font-family: 'Great Vibes', cursive;
  font-size: 35px;
  padding-top: 20px;
  padding-bottom: 15px;
  color: #3a3b3d;
  z-index: 20;
}

/* Línea vertical */
.timeline {
  position: relative;
  max-width: 600px;
  margin: 0 auto;
}
.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #ceb9af;
  transform: translateX(-50%);
  z-index: 0;
}

.timeline-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  position: relative;
  opacity: 0;
  transform: translateY(30px);
}

/* Lado izquierdo: ícono */
.lado-izquierdo {
  width: 45%;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}
.icono-wrapper {
  background-color: rgba(161, 151, 142, 0.95); 
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icono {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

/* Centro: imagen del corazón */
.corazon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.corazon-img {
  width: 22px;
  height: 22px;
}

/* Lado derecho: texto */
.lado-derecho {
  width: 45%;
  text-align: left;
  padding-left: 20px;
}
.hora {
  font-size: 18px;
  color: #292827;
  margin: 0 0 4px;
}
.nombre {
  font-size: 15px;
  color: #2c2b29;
  margin: 0;
}
</style>